import Header from './es/header-menu';
import Footer from './es/footer';
import SubscriptionForm from './es/subscription-form';
import HomePage from './es/home-page';
import TrinityCerttesolPage from './es/trinity-certtesol-page';
import OnlineCerttesolPage from './es/online-trinity-certtesol';
import DevelopingTeacherPage from './es/developing-teacher-page';
import BarcelonaPage from './es/barcelona-page';
import SevilliePage from './es/sevillie-page';
import DatesAndFeesPage from './es/dates-and-fees';
import PaymentPlanPage from './es/payment-plan-page';
import SpecialOffersPage from './es/special-offers-page';
import CareersServicePage from './es/careers-service-page';
import AccommodationPage from './es/accommodation-page';
import ResourcesPage from './es/resources-page';
import AboutPage from './es/about-page';
import WhatIsTeflPage from './es/what-is-tefl-page';
import AccreditationPage from './es/accreditation-page';
import TeamPage from './es/team-page';
import GraduatesPage from './es/graduates-page';
import WorkWithUsPage from './es/work-with-us-page';
import EntryPage from './es/entry-requirements';
import ContactUsPage from './es/contacto-page';
import FaqsPage from './es/faqs-page';
import BlogPage from './es/blog';
import StudentsVisaPage from './es/student-visas';
import HowToMakeGoodAppPage from './es/how-to-make-good-app-page';
import ApplyPage from './es/apply-page';
import TermsPage from './es/terms-and-conditions';
import PrivacyPage from './es/privacy-page';
import AllCoursesPage from './es/all-courses';
import SpanishCoursePage from './es/spanish-course-page';
import TeachingKidsPage from './es/teaching-young-learners-page';
import ClassesDeInglesPage from './es/classes-de-ingles-page';

import Components from './es/components';

import URLS from './es/urls';

const translation = {
  prefix: 'es',
  ...Header,
  ...Footer,
  ...HomePage,
  ...TrinityCerttesolPage,
  ...OnlineCerttesolPage,
  ...SubscriptionForm,
  ...DevelopingTeacherPage,
  ...BarcelonaPage,
  ...SevilliePage,
  ...DatesAndFeesPage,
  ...PaymentPlanPage,
  ...SpecialOffersPage,
  ...CareersServicePage,
  ...AccommodationPage,
  ...ResourcesPage,
  ...AboutPage,
  ...WhatIsTeflPage,
  ...AccreditationPage,
  ...TeamPage,
  ...GraduatesPage,
  ...WorkWithUsPage,
  ...EntryPage,
  ...ContactUsPage,
  ...FaqsPage,
  ...BlogPage,
  ...StudentsVisaPage,
  ...HowToMakeGoodAppPage,
  ...ApplyPage,
  ...TermsPage,
  ...PrivacyPage,
  ...AllCoursesPage,
  ...SpanishCoursePage,
  ...TeachingKidsPage,
  ...ClassesDeInglesPage,
  ...Components,
  ...URLS,
};

export default translation;
